const crimes = {
    1: {
        category: "Search for Cash",
        subcategory: "Search the train station"
    },
    2: {
        category: "Search for Cash",
        subcategory: "Search under the old bridge"
    },
    3: {
        category: "Search for Cash",
        subcategory: "Search the bins"
    },
    4: {
        category: "Search for Cash",
        subcategory: "Search the water fountain"
    },
    5: {
        category: "Search for Cash",
        subcategory: "Search the dumpsters"
    },
    6: {
        category: "Search for Cash",
        subcategory: "Search movie theater"
    },
    7: {
        category: "Sell Copied Media",
        subcategory: "Rock CDs"
    },
    8: {
        category: "Sell Copied Media",
        subcategory: "Heavy Metal CDs"
    },
    9: {
        category: "Sell Copied Media",
        subcategory: "Pop CDs"
    },
    10: {
        category: "Sell Copied Media",
        subcategory: "Rap CDs"
    },
    11: {
        category: "Sell Copied Media",
        subcategory: "Reggae CDs"
    },
    12: {
        category: "Sell Copied Media",
        subcategory: "Horror DVDs"
    },
    13: {
        category: "Sell Copied Media",
        subcategory: "Action DVDs"
    },
    14: {
        category: "Sell Copied Media",
        subcategory: "Romance DVDs"
    },
    15: {
        category: "Sell Copied Media",
        subcategory: "Sci Fi DVDs"
    },
    16: {
        category: "Sell Copied Media",
        subcategory: "Thriller DVDs"
    },
    17: {
        category: "Shoplifting",
        subcategory: "A few chocolate bars"
    },
    18: {
        category: "Shoplifting",
        subcategory: "A few bags of bonbons"
    },
    19: {
        category: "Shoplifting",
        subcategory: "A box of extra strong mints"
    },
    20: {
        category: "Shoplifting",
        subcategory: "Music Stall"
    },
    21: {
        category: "Shoplifting",
        subcategory: "Electronics stall"
    },
    22: {
        category: "Shoplifting",
        subcategory: "Computer stall"
    },
    23: {
        category: "Shoplifting",
        subcategory: "Tank Top"
    },
    24: {
        category: "Shoplifting",
        subcategory: "Trainers"
    },
    25: {
        category: "Shoplifting",
        subcategory: "Jacket"
    },
    26: {
        category: "Shoplifting",
        subcategory: "Watch"
    },
    27: {
        category: "Shoplifting",
        subcategory: "Necklace"
    },
    28: {
        category: "Shoplifting",
        subcategory: "Ring"
    },
    29: {
        category: "Pickpocketing",
        subcategory: "Hobo"
    },
    30: {
        category: "Pickpocketing",
        subcategory: "Kid"
    },
    31: {
        category: "Pickpocketing",
        subcategory: "Old woman"
    },
    32: {
        category: "Pickpocketing",
        subcategory: "Businessman"
    },
    33: {
        category: "Pickpocketing",
        subcategory: "Lawyer"
    },
    34: {
        category: "Larcency",
        subcategory: "Apartment"
    },
    35: {
        category: "Larcency",
        subcategory: "Detached house"
    },
    36: {
        category: "Larcency",
        subcategory: "Mansion"
    },
    37: {
        category: "Larcency",
        subcategory: "Cars"
    },
    38: {
        category: "Larcency",
        subcategory: "Office"
    },
    39: {
        category: "Armed Robbery",
        subcategory: "Swift robbery"
    },
    40: {
        category: "Armed Robbery",
        subcategory: "Thorough robbery"
    },
    41: {
        category: "Armed Robbery",
        subcategory: "Swift Convenience"
    },
    42: {
        category: "Armed Robbery",
        subcategory: "Thorough Convenience"
    },
    43: {
        category: "Armed Robbery",
        subcategory: "Swift Bank"
    },
    44: {
        category: "Armed Robbery",
        subcategory: "Thorough Bank"
    },
    45: {
        category: "Armed Robbery",
        subcategory: "Swift Armored Car"
    },
    46: {
        category: "Armed Robbery",
        subcategory: "Thorough Armored Car"
    },
    47: {
        category: "Transport Drugs",
        subcategory: "Transport Cannabis"
    },
    48: {
        category: "Transport Drugs",
        subcategory: "Transport Amphetamines"
    },
    49: {
        category: "Transport Drugs",
        subcategory: "Transport Cocaine"
    },
    50: {
        category: "Transport Drugs",
        subcategory: "Sell Cannabis"
    },
    51: {
        category: "Transport Drugs",
        subcategory: "Sell Pills"
    },
    52: {
        category: "Transport Drugs",
        subcategory: "Sell Cocaine"
    },
    53: {
        category: "Plant a computer virus",
        subcategory: "Simple virus"
    },
    54: {
        category: "Plant a computer virus",
        subcategory: "Polymorphic virus"
    },
    55: {
        category: "Plant a computer virus",
        subcategory: "Tunneling Virus"
    },
    56: {
        category: "Plant a computer virus",
        subcategory: "Armored Virus"
    },
    57: {
        category: "Plant a computer virus",
        subcategory: "Stealth virus"
    },
    58: {
        category: "Assassination",
        subcategory: "Assassinate a target"
    },
    59: {
        category: "Assassination",
        subcategory: "Drive by Shooting"
    },
    60: {
        category: "Assassination",
        subcategory: "Car Bomb"
    },
    61: {
        category: "Assassination",
        subcategory: "Mob Boss"
    },
    62: {
        category: "Arson",
        subcategory: "Home"
    },
    63: {
        category: "Arson",
        subcategory: "Car Lot"
    },
    64: {
        category: "Arson",
        subcategory: "Office Building"
    },
    65: {
        category: "Arson",
        subcategory: "Apartment Building"
    },
    66: {
        category: "Arson",
        subcategory: "Warehouse"
    },
    67: {
        category: "Arson",
        subcategory: "Motel"
    },
    68: {
        category: "Arson",
        subcategory: "Government Building"
    },
    69: {
        category: "Grand Theft Auto",
        subcategory: "Steal a parked car"
    },
    70: {
        category: "Grand Theft Auto",
        subcategory: "Hijack a car"
    },
    71: {
        category: "Grand Theft Auto",
        subcategory: "Steal car from showroom"
    },
    72: {
        category: "Pawn Shop",
        subcategory: "Side Door"
    },
    73: {
        category: "Pawn Shop",
        subcategory: "Rear Door"
    },
    74: {
        category: "Counterfeiting",
        subcategory: "Money"
    },
    75: {
        category: "Counterfeiting",
        subcategory: "Casino tokens"
    },
    76: {
        category: "Counterfeiting",
        subcategory: "Credit card"
    },
    77: {
        category: "Kidnapping",
        subcategory: "Kid"
    },
    78: {
        category: "Kidnapping",
        subcategory: "Woman"
    },
    79: {
        category: "Kidnapping",
        subcategory: "Undercover cop"
    },
    80: {
        category: "Kidnapping",
        subcategory: "Mayor"
    },
    81: {
        category: "Arms Trafficking",
        subcategory: "Explosives"
    },
    82: {
        category: "Arms Trafficking",
        subcategory: "Firearms"
    },
    83: {
        category: "Bombings",
        subcategory: "Bomb a factory"
    },
    84: {
        category: "Bombings",
        subcategory: "Bomb a government building"
    },
    85: {
        category: "Hacking",
        subcategory: "Hack into a Bank Mainframe"
    },
    86: {
        category: "Hacking",
        subcategory: "Hack the F.B.I Mainframe"
    }
};

export const estimated_ce = {
    "search the movie theater" : 0.025,
    "shoplift jacket" : 0.1,
    "transport cannabis" : 0.2,
    "transport amphetamines" : 0.4,
    "transport cocaine" : 0.3,
    "sell cannabis" : 0.3,
    "sell pills" : 0.2,
    "sell cocaine" : 0.3,
    "motel" : 1.0,
    "warehouse" : 1.0,
    "hijack a car" : 0.3,
    "steal a car from showroom" : 0.3,
    "pawn shop side door" : 0.6,
    "pawn shop rear door" : 0.7,
    "counterfeit money" : 0.6,
    "counterfeit casino tokens" : 0.8,
    "counterfeit credit card" : 0.7,
    "kidnap kid" : 1.7,
    "kidnap woman" : 2.0,
    "kidnap undercover cop" : 2.0,
    "kidnap mayor" : 1.9,
    "arms trafficking explosives" : 1.7,
    "arms trafficking firearms" : 2.6,
    "bomb a factory" : 2.8,
    "bomb a government building" : 2.9,
    "hack into a bank mainframe" : 0.6,
    "hack into a fbi mainframe" : 1.7,
}

let crime_keys = Object.keys(crimes);
crime_keys.forEach(key => {
    let crime = crimes[key];
    crime.estimated_ce = estimated_ce[crime.subcategory.toLowerCase()] || null
});
export default crimes;